import { IconsType } from '../components/shared'
import { ColorsV3LabelsName } from '../design-system/colors_v3'

export enum AlertSeverity {
  info,
  warning,
  danger,
}

export const SEVERITIES = [AlertSeverity.info, AlertSeverity.warning, AlertSeverity.danger]

export const AlertSeverityColor: { [key in AlertSeverity]: ColorsV3LabelsName } = {
  [AlertSeverity.info]: 'blue',
  [AlertSeverity.warning]: 'yellow',
  [AlertSeverity.danger]: 'red',
}

export const AlertSeverityIcon: { [key in AlertSeverity]: IconsType } = {
  [AlertSeverity.info]: 'infoCircle',
  [AlertSeverity.warning]: 'warningCircle',
  [AlertSeverity.danger]: 'crossCircle',
}
